import { render } from "./DisasterController.vue?vue&type=template&id=956255b2&scoped=true&ts=true"
import script from "./DisasterController.vue?vue&type=script&lang=ts"
export * from "./DisasterController.vue?vue&type=script&lang=ts"

import "./DisasterController.vue?vue&type=style&index=0&id=956255b2&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956255b2"]])

export default __exports__